import { Component } from 'react';
import { inject, observer } from 'mobx-react';

//components
import withLocalization from '~/hoc/withLocalization';
import TableWidget from '../TableWidget.js';

class ExtraworkTypes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            extrawork_types: [],
        }
        this.loadData = this.loadData.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { currentEntity } = this.props.clientStore;
        if (currentEntity.client.data && currentEntity.client.data.extendedRules) {
            const extendedRules = Object.assign({}, currentEntity.client.data.extendedRules);
            this.setState({
                extrawork_types: extendedRules.extrawork_types
            })
        }
    }

    render() {
        const { extrawork_types } = this.state;
        return (
            <div>
                <TableWidget
                    headers={['code', 'Label']}
                    metaData={[{ field: 'code', type: 'text', placeholder: 'code', required: true, unique: true },
                    { field: 'name', type: 'text', placeholder: 'Label', required: true, unique: true }]}
                    data={extrawork_types}
                    onChange={data => this.props.handleUserDataChange('extrawork_types', data)}
                />
            </div >
        );
    }
}
export default inject('clientStore')(withLocalization(observer(ExtraworkTypes)));
